import * as React from "react";
function SvgYouku(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <path
        fill="#fff"
        d="M28 20.13a2 2 0 00-.75-1.23c-.28-.24-.55-.48-.84-.71l-2.63-2.25.27-.25c.9-.75 1.81-1.55 2.68-2.35a3.34 3.34 0 00.74-1 1.52 1.52 0 00-.38-1.89 2 2 0 00-2.81.11l-4.14 3.91-.31.28v-3.17a1.49 1.49 0 00-1.05-1.49 2.36 2.36 0 00-1.43-.09l.54-1.23a1.81 1.81 0 00-.33-2.25 2.09 2.09 0 00-2.95 0 2.19 2.19 0 00-.48.75c-.47 1.06-.91 2.14-1.36 3.21l-1.79 4.22-1.05-2.55C9.3 10.58 8.68 9 8 7.44A2 2 0 005.85 6 1.79 1.79 0 004 8a3.91 3.91 0 00.28.94Q6.47 14 8.67 19a.7.7 0 010 .63c-.43.86-.82 1.75-1.23 2.63a14.05 14.05 0 00-.58 1.39 1.62 1.62 0 00.75 2.08 1.94 1.94 0 002.56-.22 5.08 5.08 0 00.75-1.19q2.6-5.79 5.17-11.58v8a1.43 1.43 0 001.39 1.34 1.86 1.86 0 002.15-.8 2.1 2.1 0 00.13-.83v-3.14l.36.28c1.49 1.29 3.06 2.59 4.59 3.9a2.15 2.15 0 002.09.45 1.49 1.49 0 001.2-1.76v-.05z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgYouku);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
